import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  async laadMeer(event) {
    try {
      const response = await get(
        `${event.params.meerUrl}?auteur_id=${event.params.auteurId}&paginanummer=${event.params.paginanummer}`,
        {
          responseKind: "turbo-stream",
        },
      );
    } catch (error) {
      console.error("Request error:", error);
    }
  }
}
